
export const environment = {
  production: false,
  API_URL: 'http://api.m-cam.cz/api/v1/',
  STATIC_EVENTS_URL: 'http://api.m-cam.cz/static-events/',
  versions: {
    app: '3.0.0'
  }
}
